import { render, staticRenderFns } from "./DuckCepstrum.vue?vue&type=template&id=6d6a728a&scoped=true"
import script from "./DuckCepstrum.vue?vue&type=script&lang=js"
export * from "./DuckCepstrum.vue?vue&type=script&lang=js"
import style1 from "./DuckCepstrum.vue?vue&type=style&index=1&id=6d6a728a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6a728a",
  null
  
)

export default component.exports